import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const sid = m[1];
    exchangeSession(sid)
      .then((user) => {
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user } });
      })
      .catch(() => {
        navigate("/", { replace: true });
      });
    // Runs once on mount (guarded by `processed` ref); deps intentionally limited.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-white">
      <div className="text-slate-500 text-sm">Securing your session…</div>
    </div>
  );
}
